import React from "react";

interface DirectionsState {
  isOpen: boolean;
  destination: string | number[] | null;
}

const initialState: DirectionsState = {
  isOpen: false,
  destination: null,
};

export default function useDirections() {
  const [state, setState] = React.useState<DirectionsState>(initialState);

  const openLocation = (destination: DirectionsState["destination"]) => {
    setState({ destination: destination, isOpen: true });
  };

  const closeLocation = React.useCallback(() => {
    setState((prevState) => ({ ...prevState, isOpen: false }));
  }, []);

  return {
    openLocation: openLocation,
    closeLocation: closeLocation,
    directionsState: state,
  };
}
